import { CallEndReason, Call, RemoteParticipant, CallAgent } from '@azure/communication-calling';
import { SelectionState } from '../RemoteStreamSelector';
import { ChatClient } from '@azure/communication-chat';

const SET_CALL_AGENT = 'SET_CALL_AGENT';
const SET_GROUP = 'SET_GROUP';
const CALL_ADDED = 'CALL_ADDED';
const CALL_REMOVED = 'CALL_REMOVED';
const SET_CALL_STATE = 'SET_CALL_STATE';
const SET_PARTICIPANTS = 'SET_PARTICIPANTS';
const SET_DOMINANT_PARTICIPANTS = 'SET_DOMINANT_PARTICIPANTS';
const CHAT_MESSAGE_RECEIVED = 'CHAT_MESSAGE_RECEIVED';
const SET_CHAT_CLIENT = "SET_CHAT_CLIENT";
const SET_SERVER_CALL_ID = 'SET_SERVER_CALL_ID';

interface SetCallAgentAction {
  type: typeof SET_CALL_AGENT;
  callAgent: CallAgent;
}

interface SetGroupAction {
  type: typeof SET_GROUP;
  group: string;
}

interface CallAddedAction {
  type: typeof CALL_ADDED;
  call: Call;
}

interface CallRemovedAction {
  type: typeof CALL_REMOVED;
  call: Call | undefined;
  incomingCallEndReason: CallEndReason | undefined;
  groupCallEndReason: CallEndReason | undefined;
}

interface SetCallStateAction {
  type: typeof SET_CALL_STATE;
  callState: string;
}

interface SetParticipantsAction {
  type: typeof SET_PARTICIPANTS;
  remoteParticipants: RemoteParticipant[];
}

interface SetDominantParticipantsAction {
  type: typeof SET_DOMINANT_PARTICIPANTS;
  dominantParticipants: SelectionState[];
}

interface ChatMessageReceivedAction {
  type: typeof CHAT_MESSAGE_RECEIVED;
  message: string ;
  messageType?:string;
}

interface SetChatClientAction {
  type: typeof SET_CHAT_CLIENT;
  chatClient: ChatClient;
}



interface SetServerCallIDAction {
  type: typeof SET_SERVER_CALL_ID;
  serverCallId: string;
}



export const setCallAgent = (callAgent: CallAgent): SetCallAgentAction => {
  return {
    type: SET_CALL_AGENT,
    callAgent
  };
};

export const setGroup = (groupId: string): SetGroupAction => {
  return {
    type: SET_GROUP,
    group: groupId
  };
};

export const callAdded = (addedCall: Call): CallAddedAction => {
  return {
    type: CALL_ADDED,
    call: addedCall
  };
};

export const callRemoved = (removedCall: Call, group: string): CallRemovedAction => {
  return {
    type: CALL_REMOVED,
    call: undefined,
    incomingCallEndReason: removedCall.direction === 'Incoming' ? removedCall.callEndReason : undefined,
    groupCallEndReason: removedCall.direction !== 'Incoming' && !!group ? removedCall.callEndReason : undefined
  };
};

export const setCallState = (callState: string): SetCallStateAction => {
  return {
    type: SET_CALL_STATE,
    callState
  };
};

export const setParticipants = (participants: RemoteParticipant[]): SetParticipantsAction => {
  return {
    type: SET_PARTICIPANTS,
    remoteParticipants: participants
  };
};

export const setDominantParticipants = (selected: SelectionState[]): SetDominantParticipantsAction => {
  return {
    type: SET_DOMINANT_PARTICIPANTS,
    dominantParticipants: selected
  };
};

export const chatMessageReceived = (message: string,messageType:string): ChatMessageReceivedAction => {
  return {
    type: CHAT_MESSAGE_RECEIVED,
    message,
    messageType
  };
};

export const setChatClient = (chatClient: ChatClient): SetChatClientAction => {
  return {
    type: SET_CHAT_CLIENT,
    chatClient
  };
};


export const setServerCallId = (serverCallId: string): SetServerCallIDAction => {
  return {
    type: SET_SERVER_CALL_ID,
    serverCallId
  };
};

export {
  SET_CALL_AGENT,
  SET_GROUP,
  CALL_ADDED,
  CALL_REMOVED,
  SET_CALL_STATE,
  SET_DOMINANT_PARTICIPANTS,
  SET_PARTICIPANTS,
  CHAT_MESSAGE_RECEIVED,
  SET_CHAT_CLIENT,
  SET_SERVER_CALL_ID
};

export type CallTypes =
  | SetCallAgentAction
  | SetParticipantsAction
  | SetDominantParticipantsAction
  | SetCallStateAction
  | SetGroupAction
  | CallAddedAction
  | CallRemovedAction
  | ChatMessageReceivedAction
  | SetChatClientAction
  | SetServerCallIDAction;
